var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "search",
      "placeholder": "Playlist Search"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "playlists"
  }, [_c('h4', [_vm._v("Playlists")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.filteredPlaylists), function(playlist) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "64"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Playlist',
          params: {
            id: playlist.playlistId
          }
        }
      }
    }, [_c('img', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "src": _vm.episodeThumbnail(playlist.episodeId),
        "alt": 'Show #' + _vm.episode(playlist.episodeId).number,
        "width": "64"
      }
    })])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "text-dark",
      attrs: {
        "to": {
          name: 'Playlist',
          params: {
            id: playlist.playlistId
          }
        }
      }
    }, [_c('h6', [_vm._v("\n              " + _vm._s(playlist.name) + "\n              "), _c('br'), _vm._v(" "), _c('small', {
      staticClass: "text-primary"
    }, [_vm._v("from Show #" + _vm._s(_vm.episode(playlist.episodeId).number))])]), _vm._v(" "), _c('span', [_vm._v("\n              (" + _vm._s(_vm.tracksForPlaylist(playlist.playlistId).length) + " tracks)\n              "), (Object.keys(_vm.playlistsForEpisode(playlist.episodeId)).length === 1) ? _c('small', {
      staticClass: "text-secondary"
    }, [_vm._v("\n                full episode\n              ")]) : _vm._e()])])], 1)])
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-240ee9b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Playlists.vue
// module id = vvrf
// module chunks = 1